import React, {useState, useRef} from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';

const PatientInfo = ({ data, width, cssClass, handlePrint }) => {

    const patientInfo = data?.data?.patientDetails || {};

   
    

    if (!data) {
        return (
            <>
                <section className='section section-1' id='patient-info'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>
                                <h2>Data not available</h2>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    } else if (data.message === "No record found!") {
        return (
            <section className="section section-1" id='patient-info'>
                
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className='container-1'>
                                <div className="col-12 col-sm-9 col-md-7">
                                    <div className="petient-details d-none d-sm-block">
                                        <div className="row">
                                            <div className="col-12 col-sm-12 ">
                                                <div className='custom-no-record'>
                                                    {data.message}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="petient-details d-sm-none">
                                        <div className="row">
                                            <div className="col-12 col-sm-12 ">
                                                <div className='custom-no-record'>
                                                    {data.message}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>                
            </section>
        )
    }

    else {
        return (
            <>
                <section className="section section-1" id='patient-info'>
                    <div className={`banner-overlay set_bg_banner ${cssClass}`}></div>
                    <div className='content-overlay'>

                   
                        <div className="container">
                            <div className="row">
                                <div className="col d-flex align-items-center pt-2 pb-2 header">
                                    <div>
                                        <img className="img-fluid logo-75" src={logo75} />
                                    </div>
                                    <div className="ms-auto">
                                        <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className='container-1'>
                                    <div className="col-12 col-sm-9 col-md-7">
                                        <div className="petient-details d-none d-sm-block">
                                            <table className="table-custom">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: 80 + 'px' }}>Name</td>
                                                        <td>:</td>
                                                        <td colSpan="4">{patientInfo.PatientName || ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ width: 80 + 'px' }}>Age</td>
                                                        <td>:</td>
                                                        <td>{patientInfo.Age || ""}</td>
                                                        <td style={{ width: 100 + 'px' }}>Gender</td>
                                                        <td>:</td>
                                                        <td>{patientInfo.Gender || ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ width: 80 + 'px' }}>Date</td>
                                                        <td>:</td>
                                                        <td>{patientInfo.RegistrationDate || ""}</td>
                                                        <td style={{ width: 100 + 'px' }}>Lab number</td>
                                                        <td>:</td>
                                                        <td>{patientInfo.LabNumber || ""}  </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="petient-details d-sm-none">
                                            <div className="row">
                                                <div className="col-12 col-sm-12 ">
                                                    <div className="table-responsive">
                                                        <table className="table-custom">
                                                            <tbody>
                                                                <tr>
                                                                    <td>Name</td>
                                                                    <td>:</td>
                                                                    <td>{patientInfo.PatientName || "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Age</td>
                                                                    <td>:</td>
                                                                    <td>{patientInfo.Age || "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Gender</td>
                                                                    <td>:</td>
                                                                    <td>{patientInfo.Gender || "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Date</td>
                                                                    <td>:</td>
                                                                    <td>{patientInfo.RegistrationDate || "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Lab number</td>
                                                                    <td>:</td>
                                                                    <td>{patientInfo.LabNumber || "-"}</td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className='container'>
                            <div className='row'>
                                <div className='container-1'>
                                    <div className="col-12 p-0">
                                        <div className="banner-image">
                                            <div className="smart-logo-wrapper">
                                                <div className="t-easy">An Easy-to-understand</div>
                                                <div className="t-helth">Health Analysis</div>
                                                <div className="t-doct">Doctor curated, AI-enhanced and personalised</div>
                                                <div className="smart-logo-wrapper-1">
                                                    <div className='color-wrapper'>
                                                        {/* <img className="s-logo" alt="" src={smartreportlogo} /> */}
                                                        <div className='text-center text-nowrap logo-text-big'>Smart</div>
                                                        <div className='text-center text-nowrap logo-text-small'>Report</div>
                                                        <div className="text-center text-nowrap package-name">{patientInfo.PackageName || "-"}</div>
                                                    </div>

                                                </div>
                                                {/* <div className="t-easy">{patientInfo.PackageName || "-"}</div> */}
                                            </div>
                                            <div className="d-line-left"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </section>
            </>
        )
    }
}

export default PatientInfo;

